import React from 'react';
import { useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import { CircularProgress } from '@material-ui/core';
import * as ROUTES from '@/constants/routes';
import { BannerButton, EmptyState, PageSurface } from '@/components/CorporateShipper/blocks';

/** The page shown in place of a carrier while it loads, or when the admin can't open it. */
const CarrierGate = ({ isPermitted, loading, error, carrier }) => {
    const navigate = useNavigate();

    // Loading comes first: the org check is a query, so the carrier isn't permitted until it returns.
    let message = 'Carrier not found.';
    if (loading) message = <CircularProgress size={28} />;
    else if (error) message = "Couldn't load this carrier. Refresh to try again.";
    else if (!isPermitted) {
        message = (
            <>
                This carrier is not part of your organization.{' '}
                <BannerButton
                    onClick={() => navigate(ROUTES.CORPORATE_USERS)}
                    css={css`
                        background: none;
                        border: none;
                        color: inherit;
                        text-decoration: underline;
                    `}
                >
                    Back to Accounts
                </BannerButton>
            </>
        );
    } else if (carrier) return null;

    return (
        <PageSurface>
            <EmptyState>{message}</EmptyState>
        </PageSurface>
    );
};

export default CarrierGate;
